import { LoadingButton } from '@mui/lab';
import { Card, CardContent } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useModal } from 'mui-modal-provider';
import { makeStyles } from 'tss-react/mui';
import useAsyncDeleteGoogleData from '../../../../hooks/useAsyncDeleteGoogleData';
import { RequestStatus } from '../../../../sic-lib/enums/RequestStatus';
import { useAppDispatch } from '../../../../store/hooks';
import { requestConfig } from '../../../../store/users';
import DialogConfirmAction from '../../../Shared/DialogConfirmAction/DialogConfirmAction';

export default function DeleteMyGoogleData() {
    const { showModal } = useModal();
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const { requestStatus, asyncDeleteGoogleData } = useAsyncDeleteGoogleData();

    const handleDelete = () => {
        const modal = showModal(DialogConfirmAction, {
            title: 'Confirm Delete ALL Google Data',
            description:
                'Deleting your Google Data will result in duplication of Calendar Events and other Google Service data within StayInContact if you reconnect your Google Account at a later time. This cannot be undone. Are you sure you wish to proceed?',
            onConfirm: async () => {
                await asyncDeleteGoogleData();

                dispatch(requestConfig());
            },
            onCancel: () => {
                modal.hide();
            },
        });
    };

    return (
        <Card>
            <CardContent>
                <LoadingButton
                    onClick={handleDelete}
                    variant="outlined"
                    color="error"
                    loading={requestStatus === RequestStatus.active}
                    size="small"
                >
                    Delete ALL Google Data
                </LoadingButton>
            </CardContent>
        </Card>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
